import {Grid} from '@mui/material';
import {useQuery} from 'react-query';
import {useNavigate} from 'react-router-dom';
import {BannerType} from '../../models/banner.model';
import {GetBanners} from '../../services/banner.service';
import {SmartImage} from '../images/SmartImage';

interface BannersProps {
    bannerType: BannerType;
    onBannerClick?: (actionUrl: string) => void;
}

const Banners = ({bannerType, onBannerClick}: BannersProps) => {
    const navigate = useNavigate();
    const {data: banners} = useQuery(['banners', bannerType], () =>
        GetBanners({bannerType})
    );

    const handleBannerClick = (actionUrl: string) => {
        if (!actionUrl) return;

        onBannerClick?.(actionUrl);

        const internalPrefix = 'internalState:';
        if (actionUrl.startsWith(internalPrefix)) {
            const path = actionUrl.slice(internalPrefix.length);
            if (path) navigate(path);
        } else {
            window.open(actionUrl, '_blank', 'noopener,noreferrer');
        }
    };

    if (!banners?.length) return null;

    return (
        <Grid
            container
            sx={{
                paddingBottom: '20px',
                width: '100%',
                flexDirection: 'column',
                marginTop: '20px',
                gap: 2,
            }}
        >
            {banners.map((banner) => (
                <Grid
                    item
                    key={banner.imageUrl}
                    sx={{
                        borderRadius: '8px',
                        marginInline: '20px',
                        objectFit: 'cover',
                        overflow: 'hidden',
                    }}
                    onClick={() => handleBannerClick(banner.actionUrl)}
                >
                    <SmartImage
                        src={banner.imageUrl}
                        alt="image"
                        imageStyle={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            display: 'block',
                            borderRadius: '8px',
                        }}
                        size={'100%'}
                        borderRadius={8}
                    />
                </Grid>
            ))}
        </Grid>
    );
};

export default Banners;
